import { BaseDataService, resourceUrlFor } from "./base.service";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, share } from "rxjs/operators";
import { Config } from "./../../resources";
import { HttpService } from "../http.service";
import { BrokerService } from "../broker.service";

@Injectable()
export class ConfigService extends BaseDataService<Config> {
  cache: Config;
  ongoingCache: Observable<Config>;

  constructor(http: HttpService, private broker: BrokerService) {
    super(http, "config");

    this.ongoingCache = this.http.request(resourceUrlFor("config")).pipe(
      map((response) => (this.cache = new Config(response))),
      share()
    );

    this.ongoingCache.subscribe((config) => broker.broadcast("config.service.current", config));
  }

  get(refreshCache?: boolean): Observable<Config> {
    if (!refreshCache && this.cache) {
      return of(this.cache);
    }

    return this.ongoingCache;
  }
}
